<template>
  <v-flex fill-height lg12 md12>
    <v-card class="fill-height">
      <v-layout column fill-height>
        <v-toolbar flat color="secondary" dense>
          <v-toolbar-title class="primarytext--text">Creazione note spese</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-layout row wrap align-center justify-space-around>
          <v-flex align-self-start shrink pt-3>
            <v-date-picker
              locale="it-IT"
              v-model="datePicker"
              color="secondary lighten-1"
              class="elevation-0"
              @change="getValute"
            ></v-date-picker>
          </v-flex>
          <v-flex v-if="!!datePicker" xs12 sm12 md12 lg8 align-self-start>
            <FormCreaNotaSpese @on-save-nota="saveNotaClick" :data="datePicker"></FormCreaNotaSpese>
          </v-flex>
          <v-flex
            v-else
            xs12
            sm8
            md8
            lg8
            align-self-center
            class="title font-weight-light grey--text pa-3 text-xs-center"
          >Seleziona la data delle spese!</v-flex>
        </v-layout>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import FormCreaNotaSpese from "./FormCreaNotaSpese.vue";

export default {
  name: "acc-create-note",
  components: {
    FormCreaNotaSpese
  },
  props: {},
  data: () => ({
    datePicker: null,
    loader: false
  }),

  watch: {},
  computed: {},
  methods: {
    saveNotaClick() {
      this.datePicker = null;
    },
    getValute(){
        this.$store.dispatch("notaSpese/getValute", this.datePicker);
    }
  }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/TabCreazioneNota.vue